import * as THREE from "three";
import heightm from './Scenes assets/Fxscene2/earthheightmap.png'
import colorm from './Scenes assets/Fxscene2/earthcolormap.jpg'
import cloudm from './Scenes assets/Fxscene2/earthcloudmap.jpg'
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader'
import { TIFFLoader } from 'three/addons/loaders/TIFFLoader.js';

let scene, camera, clock = new THREE.Clock();
let spheremesh, cloudmesh, atmospheremesh
let scrollPercent

let atmosphereshader = `
uniform vec2 u_resolution;
 void main() {

    
    vec2 uv = gl_FragCoord.xy / u_resolution.xy;

    vec3 col = vec3(0.3,1.0,1.0);
    // Output to screen
    gl_FragColor = vec4(col,0.1);
}
`
function fullscene(scene, camera) {
  this.scene = scene
  this.camera = camera
}

export default function Earth(renderer, loadingmanager, animationScripts) {


  function init() {
    const width = window.innerWidth,
    height = window.innerHeight;
    camera = new THREE.PerspectiveCamera(70, width / height, 0.01, 10);
    camera.position.z = 1.05;
    camera.rotation.z = 49.5
    camera.rotation.x = 1
    camera.rotation.y = 5
    scene = new THREE.Scene();

    //sphere
    const displacementload = new THREE.TextureLoader(loadingmanager)
  
    const earthcormap = displacementload.load(colorm)
    const maps = displacementload.load(heightm)
    const clouds = displacementload.load(cloudm)


    const SphereGeometry = new THREE.SphereGeometry(1, 500, 500)
    const cloudsphere = new THREE.SphereGeometry(1.01, 500, 500)
    const atmosphere = new THREE.SphereGeometry(1.02, 500, 500)

    const cloudsMaterial = new THREE.MeshStandardMaterial({
      map: clouds,
      side: THREE.DoubleSide,
      transparent: true,
      opacity: 0.2
    })
    
    const atmospherematerial = new THREE.ShaderMaterial({
      fragmentShader: atmosphereshader,
      transparent: true,
      
      uniforms: {
        u_resolution: { value: atmosphere.scale},
        
        u_cameraposition: { value: camera.position},
      }
    })


    const spherematerial = new THREE.MeshStandardMaterial(
        {
            color: new THREE.Color(0xffffff),
            displacementMap: maps,
            map: earthcormap,
            displacementScale: 0.02

        }
    )



    function lerp(x, y, a) {
      return (1 - a) * x + a * y;
    }

    // Used to fit the lerps to start and end at specific scrolling percentages
    function scalePercent(start, end) {
      return (scrollPercent - start) / (end - start);
    }

animationScripts.push({
  start: 80,
  end: 100,

  func: () => {

  },
  
});
animationScripts.push({
  start: 0,
  end: 100,

  func: () => {
    scrollPercent =
      ((document.documentElement.scrollTop || document.body.scrollTop) /
        ((document.documentElement.scrollHeight ||
          document.body.scrollHeight) -
          document.documentElement.clientHeight)) *
      100;


  },
  
});
    

    const light = new THREE.AmbientLight( 0x404040, 5 ); // soft white light
    scene.add( light );



    spheremesh = new THREE.Mesh(SphereGeometry, spherematerial)
    cloudmesh = new THREE.Mesh(cloudsphere, cloudsMaterial)
    atmospheremesh = new THREE.Mesh(atmosphere, atmospherematerial)
    scene.add(spheremesh)
    scene.add(cloudmesh)
    scene.add(atmospheremesh)
      
  }

  function animate() {
    const delta = clock.getDelta();
    spheremesh.rotation.y += delta / -115;
    cloudmesh.rotation.y += delta / -115;
    requestAnimationFrame(animate);

  }




  init()
  animate()
  let block = new fullscene(scene, camera)
  return block
}